import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { openWidget, closeWidget } from 'ducks/guruWidget/actions'
import { selectGuruWidgetOpen } from 'ducks/guruWidget/selectors'
import { useGuruContext } from './useGuruContext'
import { useGuruVisibility } from './useGuruVisibility'

const isEditableTarget = (target) => {
  if (!target) return false
  const tag = target.tagName
  return tag === 'INPUT' || tag === 'TEXTAREA' || target.isContentEditable
}

export function useGuruKeyboardShortcuts() {
  const dispatch = useDispatch()
  const open = useSelector(selectGuruWidgetOpen)
  const ctx = useGuruContext()
  const visible = useGuruVisibility()

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape' && open) {
        e.preventDefault()
        dispatch(closeWidget())
        return
      }

      if (!visible) return
      if (isEditableTarget(e.target)) return

      const cmdOrCtrl = e.metaKey || e.ctrlKey
      const shouldOpen = (cmdOrCtrl && (e.key === 'k' || e.key === 'K'))
        || (cmdOrCtrl && e.key === '/')

      if (shouldOpen) {
        e.preventDefault()
        if (open) {
          dispatch(closeWidget())
        } else {
          dispatch(openWidget(ctx))
        }
      }
    }

    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [dispatch, open, visible, ctx])
}
